export class OverlayPosition {
    top: string = 'auto';
    right: string = 'auto';
    bottom: string = 'auto';
    left: string = 'auto';
}



// WEBPACK FOOTER //
// ./client-src/app/core/classes/overlay-position.ts